export enum SistemaTipo {
  MinutaCredito = 2,
  MinutaMercado = 3,
  Contrapartes = 4,
  CLG = 7,
  CLFB = 8,
  Corporate = 10,
  CapitalMarkets = 11,
  NotaEstructurada = 12,
  TransferenciaTerceros = 13,
  CorporateLending = 14,
  ControlOperativo = 15,
  LEP = 16,
  LCLS = 17,
  LCTC = 18,
  AFOPU = 19,
  AFOCL = 20,
  LCSLHPTI = 21,
  NOTES = 22,
  ADCM = 23,
}


export enum MensajePais {
  Argentina = 1,
  Paraguay = 2,
  Uruguay = 3,
  Panama = 4,
  USA = 5
}